import SearchIcon from '@jetbrains/icons/search.svg'

import styles from './NoAvailableRepositories.css'

function NoAvailableRepositories() {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <SearchIcon />
      </div>
      {'No available repositories'}
    </div>
  )
}

export default NoAvailableRepositories
